import heroBg from '@/assets/about/bg.png';
import us from '@/assets/about/us.png';
import team from '@/assets/about/team.png';
import teamBg from '@/assets/about/team-bg.png';

export const HERO = {
  title: '关于我们',
  subtitle: 'AI学就爱学 · 你的专属AI学习智能体',
  image: heroBg,
};

export const INTRO = {
  title: '公司介绍',
  paragraphs: [
    '北京与爱为舞科技有限公司成立于2023年5月，致力于通过人工智能技术打造全新的AI学习智能体新范式。全面提升人才培养效果、培养规模的同时，显著降低培养成本。',
    '公司总部位于北京，并在上海建立研发中心。核心产品和服务依托于AIGC（生成式人工智能）技术，希望打造一个全时、全知、全能的AI学习智能体。借助先进的大语言模型、数字人和语音技术，构建个性化、时时在、用得起的专属全能AI学习智能体。不仅根据每个人的兴趣爱好、当下水平、学习效率、情绪状态和个人性格进行教学方法和形式的调整，互动节奏的优化，还能提供量身定制的教育解决方案，真正成为每一个人的终身学习伴侣。公司致力于通过技术创新，实现有教无类和因材施教的教育理想。',
  ],
  image: us,
};

export const TEAM = {
  title: '团队介绍',
  image: team,
  bg: teamBg,
  paragraphs: [
    '我们的核心团队汇聚了来自全球企业的杰出人才。',
    '他们曾在苹果、字节跳动、拼多多、阿里巴巴、百度、京东、腾讯、快手、高途、猿辅导、好未来、Vipkid、美团、搜狗、滴滴等知名企业担任关键职位。',
    '我们的成员不仅拥有来自北京大学、清华大学、中国人民大学、复旦大学、香港理工大学、剑桥大学、卡耐基梅隆大学、新加坡国立大学等世界知名学府的深厚学术背景，还曾荣获 iF 设计奖、吴文俊人工智能最高奖等荣誉奖项，彰显了他们在各自领域的卓越成就。',
  ],
};
